export default {
    'type': 'type'
}